/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import DtModObservable from '../../Game/DtModObservable';
import InjectableComponent from '../../Utility/Component/ComponentReference/InjectableComponent';
import ComponentBase from '../../Utility/ComponentBase';
import Reel from '../Reel';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default abstract class ReelActionBase extends ComponentBase
{
    @property(cc.Float)
    protected duration: number = .15;

    @property(Reel)
    protected reel: Reel = null;

    protected elapsedTime: number = 0;

    public abstract IsComplete: boolean;

    private _dtModRef: InjectableComponent<DtModObservable> = new InjectableComponent();
    protected get dtModObservable(): DtModObservable { return this._dtModRef.Value; }

    /** @hidden */
    protected setContexts(): void
    {
        super.setContexts();
        this._dtModRef.SetContext(DtModObservable);
    }

    protected abstract reset(): void;

    protected getReelComponent(): void
    {
        if (!this.reel)
        {
            this.reel = this.getComponent(Reel);
        }
    }

    /** Runs the action on the [[Reel]]. */
    public Run(): void
    {
        this.getReelComponent();
        if (!this.isContextSet) { this.setContexts(); }

        this.enabled = true;
        this.reset();
    }

    /** Stops the action. */
    public Stop(): void
    {
        this.enabled = false;
    }
}
